import type { CompetitionRepository } from "@/modules/leagues/repositories/CompetitionRepository";
import type { Competition } from "@/modules/football/types/football";
import { API_FOOTBALL_COMPETITIONS } from "@/config/apiFootballCompetitions";

/**
 * Mescla a lista real da API atual (chamada ao vivo, como sempre) com as
 * competições HABILITADAS da API-Football (lista estática/config, sem
 * chamada nenhuma — os dados já foram confirmados via
 * /api/debug/lookup-competitions, não precisa buscar de novo toda hora).
 * O assistente de criar liga não precisa saber a diferença.
 */
export class CompositeCompetitionRepository implements CompetitionRepository {
  constructor(private readonly primary: CompetitionRepository) {}

  async getCompetitions(): Promise<Competition[]> {
    // Resiliente: se a API atual falhar (rede etc.), ainda mostra as
    // competições da API-Football em vez de quebrar o assistente inteiro.
    let primaryList: Competition[] = [];
    try {
      primaryList = await this.primary.getCompetitions();
    } catch (err) {
      console.warn("[CompositeCompetitionRepository] falha ao buscar competições da API atual, seguindo só com API-Football:", err);
    }

    const apiFootballList: Competition[] = API_FOOTBALL_COMPETITIONS.filter((c) => c.enabled).map((c) => ({
      id: c.competitionId,
      name: c.name,
      country: c.country,
      emblemUrl: null,
      currentMatchday: null,
    }));

    // Evita mostrar duas vezes a "mesma" competição de nome parecido caso
    // a API atual já cubra algo com nome semelhante (ex: Copa do Brasil,
    // se um dia for habilitada aqui também) — compara por nome
    // normalizado, não por id (os ids nunca colidem entre as duas fontes).
    const primaryNames = new Set(primaryList.map((c) => c.name.toLowerCase().trim()));
    const deduped = apiFootballList.filter((c) => !primaryNames.has(c.name.toLowerCase().trim()));

    return [...primaryList, ...deduped];
  }
}
